var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHeart = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48 58 31.51 39.79c-3.62-4.48-3.29-10.96.75-15.06 3.58-3.58 9.39-3.61 13-.05l.14.14 2.64 2.87 2.62-2.9a9.287 9.287 0 0 1 7.24-2.6 9.46 9.46 0 0 1 6.73 3.68c3.16 4.06 3.16 9.76 0 13.82L48 58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "m48 59.49-17.21-19c-3.98-4.89-3.66-11.99.76-16.49 1.92-1.93 4.54-3 7.26-3h.09c2.75.02 5.37 1.14 7.28 3.12l1.92 2.08 1.92-2.08a10.34 10.34 0 0 1 8-2.93c2.92.27 5.6 1.74 7.4 4.06 3.42 4.43 3.44 10.6.06 15.06L48 59.49ZM38.81 23A8.25 8.25 0 0 0 33 25.44a10.344 10.344 0 0 0-.69 13.72L48 56.51 63.9 39c2.79-3.73 2.75-8.86-.1-12.54a8.611 8.611 0 0 0-6-3.3c-2.36-.17-4.69.68-6.39 2.33l-3.31 3.68-3.39-3.68A8.222 8.222 0 0 0 38.9 23h-.09Z"
  })));
};
export default SvgHeart;